import { usePendingTrucks } from './usePendingTrucks';
import PendingTruckCard from './PendingTruckCard';

function PendingTruckApprovals() {
  const {
    pendingTrucks,
    isLoading,
    isError,
    isFleetInsurance,
    approve,
    reject,
  } = usePendingTrucks();

  if (isLoading) return null;
  if (isError) {
    return (
      <div className="mb-4 w-full rounded-[8px] border border-red-200 bg-red-50 p-3 text-[12px] text-red-700">
        Could not load pending truck approvals. Please refresh and try again.
      </div>
    );
  }
  if (pendingTrucks.length === 0) return null;

  return (
    <div className="mb-4 w-full rounded-[8px] border border-yellow-200 bg-yellow-50 p-4">
      <div className="mb-3 flex items-center justify-between">
        <h2 className="text-[16px] font-semibold text-primary">
          Pending Truck Approvals ({pendingTrucks.length})
        </h2>
        <p className="text-[12px] text-graysecondary">
          New trucks detected from your ELD provider need your review.
        </p>
      </div>
      <div className="flex flex-col gap-3">
        {pendingTrucks.map((truck) => (
          <PendingTruckCard
            key={truck.truck_id}
            truck={truck}
            isFleetInsurance={isFleetInsurance}
            onApprove={approve}
            onReject={reject}
          />
        ))}
      </div>
    </div>
  );
}

export default PendingTruckApprovals;
